<template>
  <div
    class="div-aqi" 
    :style="{
      background: imglist.bg,
    }"
  >
    <div style="width: 20%">
      <img class="img-aqi-logo" :src="imglist.img" />
    </div>
    <div class="p-1" style="width: 30%">
      <ul class="listaqi">
        <li>
          <h1 class="text_value" :style="{ color: imglist.color }">
            {{ value }}
          </h1>
        </li>
        <li><h3>AQI</h3></li>
        <!-- <li class="mt-2">
          <h5 class="textHeaderth thFontthai">ดัชนีคุณภาพอากาศ</h5>
        </li> -->
      </ul>
    </div>
    <div class="p-1" style="width: 50%">
      <ul class="listaqi">
        <li><h4>AIR QUALITY</h4></li>
        <li class="mt-3">
          <h1 class="text_detail" :style="{ color: imglist.color }">
            {{ imglist.text }}
          </h1>
        </li>
        <!-- <li class="mt-3">
          <h3 class="text_detailth thFontthai">{{ imglist.textth }}</h3>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["imglist", "value"],
};
</script>

<style lang="scss" scoped>
@import "./../aqi.scss";
.div-aqi {
  align-items: center;
  height: auto;
  display: flex;
  border-radius: 130px 90px 90px 130px;
  // background: rgba(118, 210, 80, 0.51);
}

.listaqi {
  list-style: none;
  text-align: center;
  margin-bottom: 0;
}
.listaqi h4 {
  color: #1c1d23;
  font-weight: 600;
}
.div-row {
  display: flex;
  justify-content: center;
}
.roundedCardGreen-header {
  background: rgba(98, 201, 147, 0.9);
  border-radius: 50px;
  //   height: 60px;
}
.textSpansub {
  font-size: 1vw;
  font-weight: 400;
}
.headCardTe {
  //   font-size: 1.6rem;
  font-weight: 800;
}
.ml-55 {
  margin-left: 55%;
}
:fullscreen {
  .ml-55 {
    margin-left: 68%;
  }
}
</style>